import {FilterObject} from "./filter-object";

export class SameIdFilter extends FilterObject<any> {

    public filter(itemToFiltre: any): boolean {
        return this.doFilter(itemToFiltre, this.field, this.values);
    }

    public doFilter(itemToFiltre: any, field: any, value: any): boolean {
        let comp;
        let id;

        if (itemToFiltre[field]) {
            comp = itemToFiltre[field];
            if (comp["id"]) {
                id = parseInt(comp["id"]);
                return id == value["id"];
            }

        }
        return true;
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/filters/same-id.filter.ts